module.exports = __webpack_public_path__ + "static/toni-l-griffin-7cd23d06c81ce35ccdf0100dbcd1bf02.jpg";